export default "__VITE_ASSET__ece4c785__"